import React from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { toast } from "react-toastify";
import axios from "axios";
import API from "../helpers/api";
import { Multiselect } from "multiselect-react-dropdown";
import swal from "sweetalert";
let user = JSON.parse(localStorage.getItem("currentUser"));
class EditTechSuperintendent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            TechSuperintendentList: [],
            TechSuperintendentIdsList:[],
            CommonArray:[],
        }
       
    }
    componentDidMount() {
      this.props.dispatch({ type: 'SubBannerTitle', data: "Client Management" });
      var FinalArray= this.props?.TechSuperintendentlist;
      var FinalArray1=this.props.fleetManagerlist;
      var FinalArray2=this.props.TechExecutivelist

      this.state.CommonArray=this.props.fleetManagerArraylist;
      if (FinalArray && FinalArray.length > 0) {
        FinalArray.map((val, index) => {
          this.state.CommonArray = this.state.CommonArray.filter(x => x.id !== val.clientUserId);
        })
        this.setState({})
      }
      if (FinalArray1 && FinalArray1.length > 0) {
        FinalArray1.map((val, index) => {
          this.state.CommonArray = this.state.CommonArray.filter(x => x.id !== val.clientUserId);
        })
        this.setState({})
      }
      if (FinalArray2 && FinalArray2.length > 0) {
        FinalArray2.map((val, index) => {
          this.state.CommonArray = this.state.CommonArray.filter(x => x.id !== val.clientUserId);
        })
        this.setState({})
      }
   
  }
 
  onSelectChange(item) {
    this.state.TechSuperintendentIdsList = [];
     this.state.TechSuperintendentList = item;
     if (item && item.length > 0) {
       item.map((val, index) => {
         let shipnames = this.props.fleetManagerArraylist.filter(x => x.id == val.id);
         if (shipnames && shipnames.length > 0) {
           this.state.TechSuperintendentIdsList.push(shipnames[0].id);
         }
       })
     }
     this.setState({});
   }
 
   onRemoveChange(item) {
    this.state.TechSuperintendentIdsList = [];
    this.state.TechSuperintendentList = item;
    if (item && item.length > 0) {
      item.map((val, index) => {
        let shipnames = this.props.fleetManagerArraylist.filter(x => x.id == val.id);
        if (shipnames && shipnames.length > 0) {
          this.state.TechSuperintendentIdsList.push(shipnames[0].id);
        }
      })
    }
    this.setState({});
   }

    addTechSuperintendent() {
        const { dispatch, match } = this.props;
        const { TechSuperintendentinfo } = this.state;
        if (this.state.TechSuperintendentIdsList !== [] ) {
            var CommonArray=[]
              CommonArray=[...this.state.TechSuperintendentIdsList]
        let user1 = 
                 [ {
                    clientUserIds: CommonArray.length>0?CommonArray.toString():"",
                    clientId:parseInt(match.params.id),
                    isDeleted: false,
                    role: "superintendent",
                    modifiedBy: user.email
                  }]
                  let url = `${API.ClientUser}`;
                  axios.put(url, user1, {
                      headers: {
                          key: user.accessToken,
                      }
                  })
                      .then((response) => {
                          let url = `${API.ClientUser}?clientId=${match.params.id}`;
                          axios.get(url)
                              .then((response) => {
                                  let fleet = response.data && response.data.filter(r => r.role === "fleetmanager");
                                  let superintendent = response.data && response.data.filter(r => r.role === "superintendent");
                                  let executive = response.data && response.data.filter(r => r.role === "technicalexecutive");
                                  dispatch({ type: "GetFleetManagerlist", data: fleet });
                                  dispatch({ type: "GetTechSuperintendentlist", data: superintendent });
                                  dispatch({ type: "GetTechExecutivelist", data: executive });
                                  this.hideSidePanel();
                                  toast.success("Updated Successfully", {
                                    position: "top-right",
                                    autoClose: 5000,
                                    hideProgressBar: true,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    progress: undefined,
                                  });
                                dispatch({
                                      type: "getClientUsersListSuccess",
                                      data: response.data,
                                  })
                              })
                              .catch((error) => {
                                  dispatch({
                                      type: "getClientUsersListFailure",
                                      error: "ERROR"
                                  })
                              })
                              dispatch({
                                type: "postClientUserDetailsSuccess",
                                data: response.data,
                            })
                        })
                        .catch((error) => {
                            dispatch({
                                type: "postClientUserDetailsFailure",
                                error: "ERROR"
                            })
                        })
         } else {
            swal('Error!', 'Email is mandatory', 'warning');
        }
    }


    hideSidePanel() {
        this.props.dispatch({ type: "ShowSidePan", data: false });
        this.props.history.goBack();
    }

    render() {
        const { fleetManagerArraylist } = this.props;
        return (
            <div className="full-height">
                <div className="resource-list-auth-date row pt-3 ">
                    <div className='w-100'>
                        <div className="panel-box search-filter-box">
                            <button
                                className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                                onClick={() => this.hideSidePanel()}
                            >
                                &larr; Return
                            </button>
                            <div className="card mt-2 MM-card-header" style={{ backgroundColor: "white" }}>
                                <div className="card-body" style={{ padding: "0rem", backgroundColor: "#1E3A8A", color: "white" }}><h5 className="card-title ml-2 mt-2" style={{ color: "092a51" }}>Technical Superintendents</h5></div>
                            </div>
                            <div className="row search-filter-box">
                                <div className="col-lg-6">
                                   
                                    <label className="form-label">Email</label><br></br>
                                    <Multiselect
                      options={ this.state.CommonArray.length>0? this.state.CommonArray:fleetManagerArraylist}
                      displayValue="name"
                      showArrow={true}
                      isObject={true}
                      style={{
                        option: {"margin-right": 0,display: "block","font-weight": "normal",
                        },
                        chips: { "background-color": "#1a3464" },
                      }}
                      onSelect={(item) => this.onSelectChange(item)}
                      onRemove={(item) => this.onRemoveChange(item)}
                      selectedValues={this.state.TechSuperintendentList}
                      placeholder={this.state.TechSuperintendentList && this.state.TechSuperintendentList.length? "": "Select"}
                      closeIcon="cancel"
                    />
                          
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-12 search-filter-box">
                                    <div className="search-btn-col" style={{ textAlign: 'end' }}>
                                        <button className="btn btn-primary text-uppercase txtside-btn txtht-btn blue" type="submit" onClick={() => this.addTechSuperintendent()}> Add </button>
                                        <button className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3" type="button" onClick={() => this.hideSidePanel()}> Cancel </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    }
}
function mapStateToProps(state) {
    return {
        TechSuperintendentlist:state.MasterScreenReducer.TechSuperintendentlist,
        fleetManagerArraylist: state.MasterScreenReducer.FleetManagerArrayList,
    }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EditTechSuperintendent));